import gql from 'graphql-tag';

export const AdminsAndEditorsQuery = gql`
  query ($filter: JSON) {
    Users(filter: $filter) {
      username
      _id
      email
      role
    }
  }
`;

export const CreateAdminMutation = gql`
  mutation SetAdmin($userId: String) {
    setAdmin(id: $userId)
  }
`;

export const CreateEditorMutation = gql`
  mutation SetEditor($userId: String) {
    setEditor(id: $userId)
  }
`;

export const DeleteAdminMutation = gql`
  mutation DismissAdmin($userId: String) {
    dismissAdmin(id: $userId)
  }
`;

export const DeleteEditorMutation = gql`
  mutation DismissEditor($userId: String) {
    dismissEditor(id: $userId)
  }
`;
